import request from '@/utils/request';
// 下载数据列表
export function getDownloadDataList(param) {
  return request('/file-repository/fileList', {
    method: 'POST',
    data: param,
  });
}
export function getYearList() {
  return request('/file-repository/yearList', {
    method: 'GET',
  });
}
